const Divider = (props) => {
  return <div className='mb-4 relative flex justify-center'>
    <div className='pl-4 pr-4 relative bottom-3 text-primary font-retro text-2xl '>{props.children}</div>
  </div>
}


export default Divider
